import axios from "axios";
import {config} from "@/appconfig";

const controller = 'einstellungen';

export interface LandInfo {
    Id: number;
    Key: string;
    HatGutachten: boolean;
}

export interface Rechtsgutachten_Drittland_Info {
    LandId: number;
    LandKey: string;
    Bearbeiter: string;
    Datum: string;
    _keywords: string;
    RechtsgutachtenDe: boolean;
    RechtsgutachtenEn: boolean;
}

export interface Rechtsgutachten_Drittland {
    LandId: number;
    LandKey: string;
    Bearbeiter: string;
    Datum: string;
    RechtsgutachtenDe: string;
    RechtsgutachtenEn: string;
}

export class RechtsgutachtenApi {
    // public async get_infos(land_ids: number[]): Promise<Rechtsgutachten_Drittland[]>{
    //     let q = land_ids.join(',');
    //     if (q.length > 1024) throw new Error('Maxiumum query string length exceeded. Please add paging.');
    //     const response = await axios.get(`${config.apiUrl}/${controller}/infos?ids=${ids}`, config.apiHeaders);
    //     return response.data.sort((a:VTaetigkeit_info,b:VTaetigkeit_info) => b.Lfd-a.Lfd);
    // }
    
    public async Liste(): Promise<Rechtsgutachten_Drittland_Info[]>{
        const response = await axios.get(`${config.apiUrl}/${controller}/rechtsgutachten`, config.apiHeaders);
        return response.data;
    }

    public async Get(landId: number): Promise<Rechtsgutachten_Drittland>{
        const response = await axios.get(`${config.apiUrl}/${controller}/rechtsgutachten/${landId}`, config.apiHeaders);
        return response.data;
    }

    public async Laender_ohne(): Promise<LandInfo[]>{
        const response = await axios.get(`${config.apiUrl}/${controller}/rechtsgutachten/laender_ohne`, config.apiHeaders);
        return response.data;
    }

    public async Aktualisieren(land: number, RechtsgutachtenDe: string | null, RechtsgutachtenEn: string | null): Promise<void>{
        const response = await axios.put(`${config.apiUrl}/${controller}/rechtsgutachten/${land}`, {RechtsgutachtenDe, RechtsgutachtenEn}, config.apiHeaders);
        return response.data;
    }
}
